import { VideoCallMap, VideoCall, CallId, VideoCallEvent, GroupId, UtcTime } from 'shared/models';

export const Actions = {
    ECS_LIST_LOADING: 'ECS_LIST_LOADING',
    ECS_CALLS_FETCHED: 'ECS_CALLS_FETCHED',

    ECS_LIST_MSG: 'ECS_LIST_MSG',
    ECS_CALL_MSG: 'ECS_CALL_MSG',
    ECS_MSCL_MSG: 'ECS_MSCL_MSG',
    ECS_CLID_MSG: 'ECS_CLID_MSG',
    ECS_OFFR_MSG: 'ECS_OFFR_MSG',
    ECS_RJCT_MSG: 'ECS_RJCT_MSG',

    BROKEN_VIDEO_CALL: 'BROKEN_VIDEO_CALL',
    VIDEO_CALL_ENDED: 'VIDEO_CALL_ENDED',
    VIDEO_CALL_FAILED: 'VIDEO_CALL_FAILED',

    GET_VC_EVENTS_REQUEST: 'GET_VC_EVENTS_REQUEST',
    GET_VC_EVENTS_SUCCESS: 'GET_VC_EVENTS_SUCCESS',
    GET_VC_EVENTS_FAILURE: 'GET_VC_EVENTS_FAILURE',
};

export const ecsListLoading = () => ({
    type: Actions.ECS_LIST_LOADING,
});

export const ecsCallsFetched = (calls: VideoCall[]) => ({
    type: Actions.ECS_CALLS_FETCHED,
    payload: calls,
});

export const receiveEcsListMessage = (calls: VideoCallMap, meta: { nextToken: string | null }) => ({
    type: Actions.ECS_LIST_MSG,
    payload: calls,
    meta,
});

export const receiveEcsCallMessage = (call: VideoCall) => ({
    type: Actions.ECS_CALL_MSG,
    payload: call,
});

export const brokenVideoCall = (meta: { elevatorId: GroupId; ended: UtcTime }) => ({
    type: Actions.BROKEN_VIDEO_CALL,
    meta,
});

export const videoCallEnded = (callId: CallId, meta: { when: UtcTime }) => ({
    type: Actions.VIDEO_CALL_ENDED,
    payload: callId,
    meta,
});

export const videoCallFailed = (callId: CallId) => ({
    type: Actions.VIDEO_CALL_FAILED,
    payload: callId,
});

export const receiveEcsOfferMessage = (callId: CallId) => ({
    type: Actions.ECS_OFFR_MSG,
    payload: callId,
});

export const receiveEcsRejectMessage = (callId: CallId) => ({
    type: Actions.ECS_RJCT_MSG,
    payload: callId,
});

export const receiveEcsCallIdMessage = (call: VideoCall) => ({
    type: Actions.ECS_CLID_MSG,
    payload: call,
});

export const sendEcsMSCallMessage = (elevatorId: GroupId, meta: { sent: number }) => ({
    type: Actions.ECS_MSCL_MSG,
    payload: elevatorId,
    meta,
});

export const getVideoCallEventsRequest = (callId: CallId, meta?: { frames?: boolean }) => ({
    type: Actions.GET_VC_EVENTS_REQUEST,
    payload: callId,
    meta,
});
export const getVideoCallEventsSuccess = (events: VideoCallEvent[], meta: { callId: CallId; more: boolean; frames: boolean }) => ({
    type: Actions.GET_VC_EVENTS_SUCCESS,
    payload: events,
    meta,
});
export const getVideoCallEventsFailure = (err: Error, meta: { callId: CallId }) => ({
    type: Actions.GET_VC_EVENTS_FAILURE,
    payload: err,
    error: true,
    meta,
});
